import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { FC } from 'react';
import { Development } from '~/api/types';
import { DevelopmentRow } from '~/components/button/development-row';

export const DevelopmentSelectionButton: FC<DevelopmentSelectionButtonProps> = ({
  development,
  onClickWhenUrlIsNull,
}) => {
  const { customerPortalUrl } = development;

  const onClick = () => {
    if (customerPortalUrl === null) {
      onClickWhenUrlIsNull();
    } else {
      window.open(customerPortalUrl, '_blank')?.focus();
    }
  };

  return (
    <DevelopmentRow
      development={development}
      onClick={onClick}
      trailing={<ChevronRightIcon sx={{ color: 'grey.500' }} />}
    />
  );
};

export interface DevelopmentSelectionButtonProps {
  development: Development;
  onClickWhenUrlIsNull: () => void;
}
